/**
 * Shared helpers for auditor-assignment slots — single source of truth for how
 * a `getExistingAssignmentConfig` level slot's auditors are read, so the modal,
 * the drawer, and the chain display don't fork the normalization.
 */

/**
 * The auditor ids saved at a level slot as string ids. Handles the external
 * array shape (`auditorIds`), the internal/legacy single shape (`auditorId`),
 * and an empty slot.
 * @param {object} slot a level slot from getExistingAssignmentConfig.
 * @returns {string[]} the auditor ids at that slot.
 */
export const slotAuditorIds = (slot) =>
  (Array.isArray(slot?.auditorIds) && slot.auditorIds.length
    ? slot.auditorIds
    : (slot?.auditorId != null ? [slot.auditorId] : [])
  ).map(String);
